import { render, staticRenderFns } from "./VersionActions.vue?vue&type=template&id=b65aab2e&scoped=true&"
import script from "./VersionActions.vue?vue&type=script&lang=js&"
export * from "./VersionActions.vue?vue&type=script&lang=js&"
import style0 from "./VersionActions.vue?vue&type=style&index=0&id=b65aab2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65aab2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/laveto/new.laveto.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b65aab2e')) {
      api.createRecord('b65aab2e', component.options)
    } else {
      api.reload('b65aab2e', component.options)
    }
    module.hot.accept("./VersionActions.vue?vue&type=template&id=b65aab2e&scoped=true&", function () {
      api.rerender('b65aab2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "galaxy/modules/Canvas/resources/js/editor/admin/VersionActions.vue"
export default component.exports